/**
 * Extracts the href attribute value from the document's <base>.
 *
 * @returns {string | null}
 */
export function getBasePath(): string | null {
  const base = document.querySelector('head base');
  if (base) {
    return base.getAttribute('href');
  }
  return null;
}
